import Swiper from 'swiper/bundle';

// Carrossel do feed do Instagram em /conteudo/ (slides montados no servidor,
// 5 posts por slide). A inicialização morava no antigo instagramApi.js.
const swiperInstagram = () => {
  const container = document.querySelector(".instagram-swiper");
  if (!container) return;

  const ativo = document.querySelector(".swiper-numeracao-insta-ativo");
  const total = document.querySelector(".swiper-numeracao-insta-total");
  const doisDigitos = (n) => (n < 10 ? "0" + n : n);

  new Swiper(container, {
    slidesPerView: 1,
    spaceBetween: 8,
    navigation: {
      nextEl: ".swiper-button-next-insta",
      prevEl: ".swiper-button-prev-insta",
    },
    on: {
      init: function () {
        total.innerText = doisDigitos(this.slides.length);
        ativo.innerText = doisDigitos(1);
      },
      slideChange: function () {
        ativo.innerText = doisDigitos(this.activeIndex + 1);
      },
    },
  });
};

export default swiperInstagram;
